import React, { useEffect, useState } from "react";
import "./createNewQuery.css";
import Form from "react-bootstrap/Form";
import axios from "../../../axios";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import CrossQueryAttachment from "./CrossQueryAttachment";
import moment from "moment";
import { useSelector } from "react-redux";
import { isArray } from "lodash";
import CreatableSelect from "react-select/creatable";
import assets from "../../../assets/assets";

const CreateNewQuery = ({
  socket,
  editQueryData,
  setEditQueryData,
  groupData,
  change,
  headerChange,
}) => {
  console.log(editQueryData);
  let data = JSON.parse(localStorage.getItem("breathForStudent"));
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [queryTopicList, setQueryTopicList] = useState([]);
  const [isInProgress, setIsInProgress] = useState(false);
  const [attachMent2, setAttachment2] = useState([]);
  // const [booksChapter, setBooksChapter] = useState([]);
  const [bookChapter, setBookChaptor] = useState({});
  const [books, setBooks] = useState([]);
  const [attach, setAttach] = useState(
    editQueryData?.attachments?.length > 0 ? editQueryData?.attachments : []
  );
  // editQueryData?.attachments?.length > 0 && true;
  let sectionId = groupData?.section?.id;
  let standardId = groupData?.standard?.id;
  let subjectId = groupData?.subject?.id;

  const { state } = useLocation()
  // const [bookChapter, setBookChapter] = useState({
  //   books: [],
  //   chapters: [],
  // });
  // const { books, chapters } = bookChapter;
  const [queryData, setQueryData] = useState({
    query: editQueryData.query ? editQueryData.query : "",
    description: editQueryData.description ? editQueryData.description : "",
    tags: editQueryData.tags ? editQueryData.tags : [],
    bookId: editQueryData.book?.id ? editQueryData.book.id : "",
    chapterId: editQueryData.chapter?.id ? editQueryData.chapter.id : "",
  });

  const { query, description, tags, bookId, chapterId } = queryData;

  const handleClick = () => {
    change(false);
    headerChange(false);
    setEditQueryData({});
  };
  const [tagLimit, setTagLimit] = useState(false);

  const handleInputChange = (inputValue) => {
    if (inputValue.length > 20) {
      inputValue = inputValue.substring(0, 20);
      setTagLimit(true);
    } else {
      setTagLimit(false)
    }
    setQueryTopicList((prev) => [
      ...prev,
      { value: inputValue, label: inputValue },
    ]);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        let response = await axios.get(
          // `/school/book/get/standardId/${standardId}?` +
          //   `${sectionId ? `sectionId=${sectionId}&` : ``}` +
          //   `${subjectId ? `subjectId=${subjectId}&` : ``}`

          `/cm/library/book/getBookByClassSectionSubject?standard_id=${standardId}&section_id=${sectionId}&subject_id=${subjectId}&timetableSessionId=${data?.timetable_session?.id}`
        );
        response = response?.data?.data;
        if (isArray(response)) {
          let bookCh = {};
          response[0].bookInfo.map((val) => {
            bookCh[val.id] = val;
          })
          setBookChaptor(bookCh);
          setBooks(response[0].bookInfo);
          // console.log("bookCh : ", bookCh);
          // console.log("response[0].bookInfo : ", response[0].bookInfo);
        }
        // const booksArray = books.data.data?.map((item) =>
        //   item.bookInfo.map((book) => ({ label: book.name, value: book.id }))
        // );


        // const chapterArray = books.data.data?.map((item) =>
        //   item.bookInfo.map((book) => book.chapterData.map((chaptersdata) => ({ value: chaptersdata.id, label: chaptersdata.chapterName })))
        // )

        // books &&
        //   setBookChapter({
        //     chapters: chapterArray[0],
        //     books: booksArray[0],
        //   })
        // setBooksChapter(chapterArray[0]);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const getData = async () => {
  //     // try {
  //     //   let chapter = await axios.get(`/school/chapter/get/bookId/${bookId}`);
  //     //   chapter &&
  //     //     setBookChapter({
  //     //       ...bookChapter,
  //     //       chapters: chapter.data.data,
  //     //     });
  //     // } catch (error) {
  //     //   console.log(error);
  //     // }
  //     if (queryData.bookId) {
  //       const chapterArray = booksChapter
  //         .map((item) =>
  //           item.bookInfo.map((book) => {
  //             if (queryData.bookId === book.id) {
  //               return book.chapterData;
  //             }
  //           })
  //         )
  //         .filter((value) => value !== undefined);
  //       chapterArray &&
  //         setBookChapter({
  //           ...bookChapter,
  //           chapters: chapterArray[0],
  //         });
  //       console.log("booksChapter1", booksChapter);
  //     }
  //   };
  //   getData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [queryData.bookId]);

  useEffect(() => {
    const getTags = async () => {
      try {
        let tags = await axios.get(`/query/tags/get`);
        let tagList = tags?.data?.data?.map((tag) => {
          return { label: tag, value: tag };
        });
        tagList.length > 0 && setQueryTopicList(tagList);
      } catch (error) {
        console.log(error);
      }
    };
    getTags();
  }, []);

  const handleSubmit = async (e) => {
    setIsInProgress(true);
    e.preventDefault();
    // let topic = tags.length > 1 ? tags.join(" ").split(' ') : tags;
    // console.log("topic", topic)
    let newQuery = {
      user_id: currentUser?.id,
      query,
      group_id: state.groupId,
      description,
      tags: tags,
      book_id: bookId,
      chapter_id: chapterId,
      attachments: attach,
      status: "pending",

    };
    // if (attach) {
    //   if (editQueryData?.attachments?.length > 0) {
    //     newQuery.attachments = editQueryData.attachments;
    //   } else {
    //     const formData = new FormData();
    //     formData.append("name", attach.name);
    //     formData.append("uploadQueryAttachment", attach);
    //     try {
    //       const res = await axios.post(
    //         `/api/v1/query/uploadAttachment/userId/${teacher_id}`,
    //         formData
    //       );
    //       newQuery.attachments = res.data.data;
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    // }
    try {
      let res;
      Object.keys(editQueryData).length > 0
        ? (res = await axios.put(`/query/update/${editQueryData.id}`, newQuery))
        : (res = await axios.post(
          `/query/create/groupId/${state.groupId}`,
          newQuery
        ));

      // socket.emit("query", res.data.data);

      res && window.location.reload();
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  const handleAttachment = async (e) => {
    let attachments = [];
    let files = e.target.files; // Get files from event
    let totalSizeInBytes = attachMent2.reduce(
      (acc, file) => acc + file.size,
      0
    );
    let fileCount = attach.length;
    if (files) {
      for (const file of files) {
        if (
          fileCount < 5 &&
          totalSizeInBytes + file.size <= 10 * 1024 * 1024 &&
          validateFileType(file)
        ) {
          try {
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadQueryAttachment", file);
            let res = await axios.post(
              `/query/uploadAttachment/userId/${currentUser?.id}`,
              formData
            );
            res && attachments.push(res.data.data);
            setAttachment2((prev) => [...prev, file]);
            totalSizeInBytes += file.size;
            fileCount += 1;
          } catch (error) {
            console.log(error);
          }
        } else {
          setIsValidFileType(false);
        }
      }
      if (attachments.length > 0) {
        setAttach((prev) => [...prev, ...attachments]);
      }
    }

    // Reset the input value to allow reselecting the same file again
    e.target.value = "";
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.pptx|\.ppt|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name) || attach.length > 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  // const timeHelper = (a) => {
  //   const dateObj = new Date(a);
  //   const day = dateObj.getUTCDate();
  //   const month = dateObj.getUTCMonth() + 1;
  //   const year = dateObj.getUTCFullYear();
  //   const hours = dateObj.getUTCHours();
  //   const minutes = dateObj.getUTCMinutes();
  //   const seconds = dateObj.getUTCSeconds();
  //   // let meridiem = "AM";
  //   // if (hours >= 12) {
  //   //   meridiem = "PM";
  //   //   hours -= 12;
  //   // }
  //   // if (hours === 0) {
  //   //   hours = 12;
  //   // }
  //   const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   return outputDateString;
  // };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1;
    const year = localDate.getFullYear();
    const hours = localDate.getHours();
    const minutes = localDate.getMinutes();
    const seconds = localDate.getSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };


  return (
    <>
      <div
        // className=" px-4 py-3 mt-4 mx-5 create_query_box"
        className="create_query_box px-4 w-full"
        style={{
          backgroundColor: "#ffebd3",
          height: "70px",
        }}
      >
        <div className="d-flex align-items-center justify-content-between mt-[20px]">
          {Object.keys(editQueryData).length > 0 ? (
            <div className="d-flex flex-column">
              <span className="threade_header">Edit Query</span>
              <span className="query_last_modified">
                Last Modified : &nbsp;
                {moment(timeHelper(editQueryData?.updated_at)).format(
                  "hh:mm A"
                )}
                &nbsp; | &nbsp;
                {moment(timeHelper(editQueryData?.updated_at)).format(
                  "DD MMM YYYY "
                )}
              </span>
            </div>
          ) : (
            <span className="threade_header">Create new thread</span>
          )}
          <img
            src={assets.CrossIcon}
            className="w-7"
            alt=""
            onClick={handleClick}
          />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mt-5">
            {/* <Form.Control
              type="text"
              placeholder="Add Topic"
              className=" query_field_box py-2"
              value={queryData?.tags}
              onChange={(e) =>
                setQueryData({ ...queryData, tags: e.target.value })
              }
            /> */}
            {tagLimit && (
              <p className="SpclStyle form-control">Tag length exceeded, please enter a tag less than 20 Characters.</p>
            )}
            <div className="mt-1 addTopic">
              <CreatableSelect
                style={{ width: "100%" }}
                className="border-1 border-black rounded-lg text-[15px]"
                placeholder="⊕ Add Topic NEW*"
                options={queryData.tags.length >= 3 ? [] : queryTopicList}
                isMulti
                maxLength={20}
                defaultValue={
                  tags.length > 0 &&
                  tags.map((tag) => ({
                    value: tag,
                    label: tag,
                  }))
                }
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions.map(
                    (option) => option.value
                  );
                  setQueryData({ ...queryData, tags: selectedValues });
                }}
                onInputChange={(e) => handleInputChange(e)}
                styles={{
                  placeholder: (provided) => ({
                    ...provided,
                    color: "#555",
                    fontWeight: 500,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    marginTop: '0',
                    borderTop: 'none'
                  }),
                }}
              />
            </div>
          </div>
          <div className="mt-3">
            <Form.Select
              className="query_field_box p-2 mr-1 form-control bello1"
              onChange={(e) => {
                const selectedBookValue = e.target.value;
                setQueryData({
                  ...queryData,
                  bookId: selectedBookValue === "Select Book" ? "" : selectedBookValue,
                })
              }}
            >
              {editQueryData?.book ? (
                <option value={editQueryData?.book?.id}>
                  {editQueryData?.book?.name}
                </option>
              ) : (
                <option style={{ color: "#99adbb" }}>Select Book*</option>
              )}
              {books.length !== 0 &&
                // books.map(
                //   (book) =>
                //     editQueryData?.book?.value !== book.value && (
                //       <option key={book.value} value={book.value}>
                //         {book.label}
                //       </option>
                //     )
                // )
                books.map((book) => <option key={book.id} value={book.id}>{book.name}</option>)
              }
            </Form.Select>
            <Form.Select
              className="query_field_box py-2 mt-3 form-control bello1"
              onChange={(e) => {
                const selectedChapterValue = e.target.value;
                setQueryData({
                  ...queryData,
                  chapterId: selectedChapterValue === "Select Chapter" ? "" : selectedChapterValue
                })
              }}
            >
              {editQueryData?.chapter ? (
                <option value={editQueryData?.chapter?.id}>
                  {editQueryData?.chapter?.name}
                </option>
              ) : (
                <option style={{ color: "#99adbb" }}>Select Chapter*</option>
              )}
              {/* {booksChapter[0] &&
                booksChapter[0]?.length !== 0 &&
                booksChapter[0].map(
                  (chapter) =>
                    editQueryData?.chapter?.id !== chapter.value && (
                      <option key={chapter.value} value={chapter.value}>
                        {chapter.label}
                      </option>
                    )
                )} */
                queryData.bookId ? bookChapter[queryData?.bookId]?.chapterData?.map((chapter) => <option key={chapter.id} value={chapter.id}>{chapter.chapterName}</option>) : null
              }


            </Form.Select>
          </div>
          <div className="mt-3">
            <Form.Control
              type="text"
              placeholder="Add query title*"
              className=" query_field_box py-2 form-control bello1"
              maxLength={150}
              value={queryData.query}
              onChange={(e) =>
                setQueryData({ ...queryData, query: e.target.value })
              }
            />
          </div>
          <textarea
            type="text"
            placeholder="Query description*"
            className="w-100 mt-3 query_text_field bello1"
            maxLength={500}
            value={queryData.description}
            onChange={(e) =>
              setQueryData({ ...queryData, description: e.target.value })
            }
          />
          <div className="mt-3 me-3 gap-3 d-flex align-items-center justify-content-end query_attach_btn">
            <div className="mb-2 d-flex flex-wrap ">
              {attach.length > 0 &&
                attach.map((item, index) => (
                  <CrossQueryAttachment
                    key={index}
                    attachment={item}
                    indexToRemove={index}
                    setAttachment2={setAttachment2}
                    attachMent2={attachMent2}
                    setAttach={setAttach}
                  />
                ))}
            </div>
            <input
              id="attachFile"
              type="file"
              accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.mp3,.mp4"
              multiple
              style={{ display: "none" }}
              onChange={handleAttachment} // Pass the event directly
            />
            <label
              className="d-flex align-items-center gap-1 mt-2"
              htmlFor="attachFile"
            >
              <img src={assets.UploadIcon} alt="UploadIcon" className="w-8 h-8 cursor-pointer" />
            </label>
            {Object.keys(editQueryData).length > 0 ? (
              <button type="submit" className="btn px-4 post_btn1">
                Update
              </button>
            ) : (
              <button
                disabled={!query || !description || !chapterId || !bookId || queryData.tags.length === 0 || isInProgress}
                type="submit"
                className="btn px-4 post_btn1"
              >
                Publish
              </button>
            )}
          </div>
        </form>
        {!isValidFileType && (
          <p id="errorMsg">
            "Exceeded Limit !!
            Max 5 attachments and total of 10 MB size is allowed."
          </p>
        )}
      </div>
    </>
  );
};

export default CreateNewQuery;
